import NoSubscriptionException from '../errors/NoSubscriptionException';
import { ParsedResponse } from '../types/types';

export default ([res, json]: ParsedResponse): ParsedResponse => {
  if (res.status === 402) {
    throw new NoSubscriptionException();
  }

  return [res, json];
};
